<script lang="ts">
  import { onMount } from 'svelte';
  import { querystring } from 'svelte-spa-router';
  import RepositoryFactory, { INVITATION_UMOBILED } from '../../../repositories/RepositoryFactory';
  import { AnalyzeEncryptedSlnDataResult } from '../../../repositories/invitationumobiled';
  import NotFound from './NotFound.svelte';

  type TDisplay = 'SUCCESS' | 'FAILURE' | 'ERROR';
  let display: TDisplay = 'SUCCESS';
  const transitionDisplay = (nextDisplay: TDisplay) => {
    display = nextDisplay;
  };
  const repository = RepositoryFactory[INVITATION_UMOBILED];

  $: slnUrl = null;

  onMount(() => {
    const encryptValue = $querystring.replace('EncryptValue=', '');
    if (!encryptValue) {
      transitionDisplay('ERROR');
      return;
    }

    repository
      .analyzeEncryptedSlnData({ encryptValue: encryptValue })
      .then((response: AnalyzeEncryptedSlnDataResult) => {
        if (response?.slnResponseCd === 'SUCCESS') {
          transitionDisplay('SUCCESS');
        } else if (response.slnResponseCd === 'FAILURE') {
          slnUrl = response.slnUrl;
          transitionDisplay('FAILURE');
        } else {
          transitionDisplay('ERROR');
        }
      })
      .catch(() => {
        transitionDisplay('ERROR');
      });
    removeHistroyState();
  });

  const removeHistroyState = () => {
    // URLからクエリパラメータを削除し履歴エントリー更新
    const current = window.location.href;
    const after = current.substring(0, current.indexOf('?EncryptValue='));
    history.replaceState('', '', after);
  };
</script>

<!-- 本体 -->
{#if display === 'SUCCESS'}
  <div class="flex flex-col justify-between items-center login-background">
    <header class="container top-0 z-0">
      <div class="justify-between items-center" style="height:56px">
        <img style="height:36px" class="object-none w-full" src="/image/unext_communication_logo.svg" alt="logo" />
      </div>
    </header>

    <main class="container mt-10 mb-auto">
      <div class="flex justify-center text-2xl">U-mobile(d)移管特別オファー申込ページ</div>

      <div class="flex justify-center mt-20">
        <div class="content-center justify-items-center p-2 lg:w-1/2 w-full">
          <div class="mb:font-sm">
            <ul class="list-none">
              <li>
                <p>クレジットカード情報が正常に登録完了しました。</p>
              </li>
              <li>
                <p>SIMの発送準備が整い次第ご登録住所に送付させていただきます。</p>
              </li>
              <li>
                <p>ご到着まで今しばらくお待ちください。</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex justify-center mt-10 mb-10">
        <button
          class="tracking-widest text-center text-sm underline h-auto w-auto"
          on:click={() => (window.location.href = 'https://www.umobile.jp/info/umb2025070102')}
        >
          サービス提供終了&代替サービス告知へ</button
        >
      </div>
    </main>

    <footer class="container" />
  </div>
{:else if display === 'FAILURE'}
  <div class="flex flex-col justify-between items-center login-background">
    <header class="container top-0 z-0">
      <div class="justify-between items-center" style="height:56px">
        <img style="height:36px" class="object-none w-full" src="/image/unext_communication_logo.svg" alt="logo" />
      </div>
    </header>

    <main class="container mt-10 mb-auto">
      <div class="flex justify-center text-2xl">U-mobile(d)移管特別オファー申込ページ</div>

      <div class="flex justify-center mt-20">
        <div class="content-center justify-items-center p-2 lg:w-1/2 w-full">
          <div class="mb:font-sm">
            <ul class="list-none">
              <li>
                <p>クレジットカード情報が正常に登録できませんでした。</p>
              </li>
              <li>
                <p>ご利用可能なクレジットカードをご用意いただき、あらためて下記リンクよりご登録してください。</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex justify-center my-10">
        <div class="content-center shadow-sm p-4 form-background lg:w-1/2 w-full">
          <div class="content-help-title-xl text-center">クレジットカード情報登録</div>

          <div class="flex justify-center items-center border-2 border-gray-900 text-blue-700 p-4 my-5 w-full">
            <button
              class="tracking-widest text-center text-sm underline h-auto w-auto"
              on:click={() => (window.location.href = `${slnUrl}`)}
            >
              クレジットカード情報登録画面へ</button
            >
          </div>
        </div>
      </div>
    </main>

    <footer class="container" />
  </div>
{:else}
  <NotFound />
{/if}

<style lang="postcss">
  .login-background {
    background-color: white;
  }

  .content-help-title-xl {
    @apply text-xl font-semibold text-gray-900;
  }

  .form-background {
    background-color: rgba(0, 0, 0, 0.02);
  }
</style>
